import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { CompareList } from "../../types";

import CompareRowText from "./CompareRowText";
import CompareRowFlag from "./CompareRowFlag";
import CompareRowBoolean from "./CompareRowBoolean";
import { useTranslation } from "react-i18next";

const ScoutCompare = React.memo(({ compareUsersList }: { compareUsersList: any }) => {
  const { t } = useTranslation();

  const scoutOverViewList: CompareList[] = [
    { label: t("components.compare.countriesOfScouting"), key: "countriesWorkedIn", type: "flag" },
    { label: t("components.compare.cityOfScouting"), key: "city", type: "text", isTranslated: true },
    { label: t("components.compare.typeOfScouting"), key: "typeOfScouting", type: "text", isTranslated: true },
  ];

  const nationalityAndLocationList: CompareList[] = [
    { label: t("components.compare.nationality"), key: "nationality", type: "flag" },
    { label: t("components.compare.country"), key: "country", type: "flag" },
  ];

  const skillsList: CompareList[] = [{ label: t("components.compare.skills"), key: "skills", type: "text" }];

  const renderCompareRow = useCallback((item: CompareList, index: number, list: CompareList[]) => {
    const { label, key, type, isTranslated } = item;
    const totalRows: number = list.length;
    const isLastRow: boolean = index + 1 === totalRows;

    switch (type) {
      case "text":
        return (
          <CompareRowText
            compareUsersList={compareUsersList}
            label={label}
            dataKey={key}
            isLastRow={isLastRow}
            isTranslated={isTranslated}
          />
        );
      case "flag":
        return <CompareRowFlag compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "boolean":
        return (
          <CompareRowBoolean compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />
        );
      default:
        return null;
    }
  }, []);

  return (
    <>
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.scoutOverview")}
      </Typography>
      {scoutOverViewList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.nationalityAndLocation")}
      </Typography>
      {nationalityAndLocationList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.skills")}
      </Typography>
      {skillsList.map(renderCompareRow)}
    </>
  );
});

export default ScoutCompare;
